// サブドメイン(tw|hk|www|cn)を.に置き換える => .(staging-)wamazing.com

import { isBrowser } from 'src/libs/wa/utils/env';

// cnのステージング、プロダクションの場合はkaimonoを.に置き換える => .(staging|p).wamazing-cn.com
export function getDomainForCookie(): string | undefined {
  if (isBrowser() && window.location && window.location.href) {
    const url = new URL(window.location.href);

    if (url.hostname) {
      const domain = url.hostname.replace(/.+?\./, '.');
      return domain;
    }
  }

  return;
}
